// The intro video shown when the app opens (logged-out users).
//
// Files live in frontend/public/intro/. To replace a video, upload the
// new file under the same name and bump VIDEO_VERSION: the frontend
// host caches static files for a long time, and the version in the URL
// makes every phone fetch the new one.
export const VIDEO_VERSION = 1;

// One video for now (English). To add Hausa, put intro-ha.mp4 in
// frontend/public/intro/ and add its line back:
//   { lang: 'ha', label: 'Hausa', src: '/intro/intro-ha.mp4' },
// The language buttons appear by themselves once there are two videos.
export const INTRO_VIDEOS = [
  { lang: 'en', label: 'English', src: '/intro/intro-en.mp4' },
];

export function introVideoFor(lang) {
  return INTRO_VIDEOS.find((v) => v.lang === lang) || INTRO_VIDEOS[0];
}

export function introVideoUrl(video) {
  return `${video.src}?v=${VIDEO_VERSION}`;
}
